import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/form/index.js
// module id = 1357
// module chunks = 0